<app-toolbar></app-toolbar>
<div class="app-body">
  <div class="working-place">
    <div class="viewer-block">
      <app-info-panel-about-claimant-user
        *ngIf="stateProjectManagerService.isPanelForClaimantUserVisible"
      ></app-info-panel-about-claimant-user>
      <app-viewer
        id="app-viewer"
        class="viewer"
        [ngClass]="{
          'padding-height-of-viewer':
            stateProjectManagerService.isPanelForClaimantUserVisible
        }"
      >
      </app-viewer>
    </div>
    <div class="viewer-right-panel">
      <app-viewer-right-panel> </app-viewer-right-panel>
    </div>
  </div>
</div>

<ng-template #projectLeftPortal>
  <div class="toolbar-navbar">
    <img class="sn-logo" src="../../assets/images/sn-logo-yellow-small.png" alt="sn-logo" />
  </div>
  <mat-divider [vertical]="true"></mat-divider>
  <div class="toolbar-identifier">
    <div>Case ID: {{ getIdentifier() }}</div>
    <div *ngIf="caseDetails">
      <div>{{ replaceNull(caseDetails.studyDescription).modifiedString }} {{ replaceNull(caseDetails.studyDescription).length > 0 && replaceNull(caseDetails.modality).length > 0 ? '-' : '' }} {{ replaceNull(caseDetails.modality).modifiedString == 'MR' ? 'MRI' : caseDetails.modality }}</div>
    </div>
  </div>
</ng-template>
